<template>
  <div class="wrapper">
    <!-- 返回按钮 -->
    <div class="back-btn-box">
      <button-a class="goBackBtn" color="#707070" bgcolor="transparent" @click.native="back()">
        <i class="el-icon-back"></i> 返回
      </button-a>
    </div>
    <!-- 员工信息 -->
    <div class="infomation white_box">
      <p class="infomation-title">员工信息</p>
      <div class="content">
        <img class="user_picture" src="@/assets/icons/Personalinformation@2x.png" alt />
        <div class="key-value">
          <div class="item">
            <div class="font_14_gray left row-end">员工姓名</div>
            <div class="font_14_black right row">
              {{empInfo.employeeName || ""}}
              <tag
                v-show="empInfo.isOnWorked"
                class="tag"
                name="在职"
                color="#f26828"
                bgcolor="#fdf0ea"
                bdcolor="#f26828"
              />
            </div>
          </div>
          <div class="item" style="margin-bottom: 0;">
            <div class="font_14_gray left">所属企业</div>
            <div class="font_14_black right">{{empInfo.customerName|| ""}}</div>
          </div>
        </div>
        <div class="key-value">
          <div class="item">
            <div class="font_14_gray left">证件号码</div>
            <div class="font_14_black right">{{empInfo.idCard|| ""}}</div>
          </div>
          <div class="item" style="margin-bottom: 0;">
            <div class="font_14_gray left">参保城市</div>
            <div class="font_14_black right">{{empInfo.joinCity|| ""}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 社保信息 -->
    <div class="infomation white_box">
      <p class="infomation-title">
        社保信息
        <tag v-if="inSocial" class="tag" name="已参保" color="#f26828" bgcolor="#fdf0ea" bdcolor="#f26828" />
        <tag v-else class="tag" name="未参保" color="#f26828" bgcolor="#fdf0ea" bdcolor="#f26828" />
      </p>
      <div class="content">
        <sum title="企业缴纳金额" :amount="money(socialInfo.companyTotal)" num_up>
          <img class="icon" src="@/assets/icons/Organizationpayment@2x.png" alt />
        </sum>
        <sum title="个人缴纳金额" :amount="money(socialInfo.personTotal)" num_up>
          <img class="icon" src="@/assets/icons/Personalpayment@2x.png" alt />
        </sum>
        <sum title="总金额合计" :amount="money(socialInfo.payTotal)" num_up>
          <img class="icon" src="@/assets/icons/Salaryamount@2x.png" alt />
        </sum>
      </div>
    </div>
    <!-- 缴纳明细 -->
    <div class="contract white_box">
      <el-tabs v-model="ss_activeTab">
        <el-tab-pane label="企业缴纳明细" name="ss_first">
          <div class="block">
            <div class="session table-session">
              <div class="session-content table-shadow">
                <el-table
                  :data="socialInfo.details || []"
                  max-height="466"
                  stripe
                  tooltip-effect="dark"
                  :header-row-style="{height: '68px', fongSize: '14px', color: '#000', backgroundColor: '#fdf0ea'}"
                  :header-cell-style="{backgroundColor: 'transparent'}"
                  :row-style="{height: '60px', backgroundColor: '#fff'}"
                  style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
                >
                  <el-table-column width="35"></el-table-column>

                  <el-table-column type="index" label="序号" width="92"></el-table-column>
                  <el-table-column prop="insuranceName" label="险种名称" width="180"></el-table-column>
                  <el-table-column prop="companyBasePay" label="缴纳基数" width="180"></el-table-column>
                  <el-table-column label="缴纳比例" width="180">
                    <template slot-scope="scope">{{percent(scope.row.companyPayRate)}}</template>
                  </el-table-column>
                  <el-table-column label="缴纳金额" width="180">
                    <template slot-scope="scope">{{(scope.row.companyRealPay || 0).toFixed(2)}}</template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="个人缴纳明细" name="ss_second">
          <div class="block">
            <div class="session table-session">
              <div class="session-content table-shadow">
                <el-table
                  :data="socialInfo.details || []"
                  max-height="466"
                  stripe
                  tooltip-effect="dark"
                  :header-row-style="{height: '68px', fongSize: '14px', color: '#000', backgroundColor: '#fdf0ea'}"
                  :header-cell-style="{backgroundColor: 'transparent'}"
                  :row-style="{height: '60px', backgroundColor: '#fff'}"
                  style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
                >
                  <el-table-column width="35"></el-table-column>
                  <el-table-column type="index" label="序号" width="92"></el-table-column>
                  <el-table-column prop="insuranceName" label="险种名称" width="180"></el-table-column>
                  <el-table-column prop="personalBasePay" label="缴纳基数" width="180"></el-table-column>
                  <el-table-column label="缴纳比例" width="180">
                    <template slot-scope="scope">{{percent(scope.row.personalPayRate)}}</template>
                  </el-table-column>
                  <el-table-column label="缴纳金额" width="180">
                    <template slot-scope="scope">{{(scope.row.personalRealPay).toFixed(2)}}</template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 公积金信息 -->
    <div class="infomation white_box" style="margin-top: 32px">
      <p class="infomation-title">
        公积金信息
        <tag v-if="inGJJ" class="tag" name="已参保" color="#f26828" bgcolor="#fdf0ea" bdcolor="#f26828" />
        <tag v-else class="tag" name="未参保" color="#f26828" bgcolor="#fdf0ea" bdcolor="#f26828" />
      </p>
      <div class="content">
        <sum title="企业缴纳金额" :amount="gjjInfo.companyTotal" num_up>
          <img class="icon" src="@/assets/icons/Organizationpayment@2x.png" alt />
        </sum>
        <sum title="个人缴纳金额" :amount="gjjInfo.personTotal" num_up>
          <img class="icon" src="@/assets/icons/Personalpayment@2x.png" alt />
        </sum>
        <sum title="总金额合计" :amount="gjjInfo.payTotal" num_up>
          <img class="icon" src="@/assets/icons/Salaryamount@2x.png" alt />
        </sum>
      </div>
    </div>
    <!-- 缴纳明细 -->
    <div class="contract white_box">
      <el-tabs v-model="gjj_activeTab">
        <el-tab-pane label="企业缴纳明细" name="gjj_first">
          <div class="block">
            <div class="session table-session">
              <div class="session-content table-shadow">
                <el-table
                  :data="gjjInfo.details || []"
                  max-height="466"
                  stripe
                  tooltip-effect="dark"
                  :header-row-style="{height: '68px', fongSize: '14px', color: '#000', backgroundColor: '#fdf0ea'}"
                  :header-cell-style="{backgroundColor: 'transparent'}"
                  :row-style="{height: '60px', backgroundColor: '#fff'}"
                  style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
                >
                  <el-table-column width="35"></el-table-column>

                  <el-table-column type="index" label="序号" width="92"></el-table-column>
                  <el-table-column prop="insuranceName" label="险种名称" width="180"></el-table-column>
                  <el-table-column prop="companyBasePay" label="缴纳基数" width="180"></el-table-column>
                  <el-table-column label="缴纳比例" width="180">
                    <template slot-scope="scope">{{percent(scope.row.companyPayRate)}}</template>                    
                  </el-table-column>
                  <el-table-column label="缴纳金额" width="180">
                    <template slot-scope="scope">{{(scope.row.companyRealPay || 0).toFixed(2)}}</template>                    
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="个人缴纳明细" name="gjj_second">
          <div class="block">
            <div class="session table-session">
              <div class="session-content table-shadow">
                <el-table
                  :data="gjjInfo.details"
                  max-height="466"
                  stripe
                  tooltip-effect="dark"
                  :header-row-style="{height: '68px', fongSize: '14px', color: '#000', backgroundColor: '#fdf0ea'}"
                  :header-cell-style="{backgroundColor: 'transparent'}"
                  :row-style="{height: '60px', backgroundColor: '#fff'}"
                  style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
                >
                  <el-table-column width="35"></el-table-column>
                  <el-table-column type="index" label="序号" width="92"></el-table-column>
                  <el-table-column prop="insuranceName" label="险种名称" width="180"></el-table-column>
                  <el-table-column prop="personalBasePay" label="缴纳基数" width="180"></el-table-column>
                  <el-table-column label="缴纳比例" width="180">
                    <template slot-scope="scope">{{percent(scope.row.personalPayRate)}}</template>                    
                  </el-table-column>
                  <el-table-column label="缴纳金额" width="180">
                    <template slot-scope="scope">{{scope.row.personalRealPay.toFixed(2)}}</template>                    

                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { Get } from "@/js/http.js";
import { toPercent, moneyFormat } from "@/js/tool.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      id: this.$route.params.id,
      ss_activeTab: "ss_first",
      gjj_activeTab: "gjj_first",
      tableData: [
        /* { name: "aa", date: "2019" },
        { name: "aa", date: "2019" },
        { name: "aa", date: "2019" },
        { name: "aa", date: "2019" },
        { name: "aa", date: "2019" },
        { name: "aa", date: "2019" }*/
      ],
      empInfo: {},
      socialInfo: {},
      gjjInfo: {}
    };
  },
  watch: {},
  computed: {
    inSocial() {
      let bool = !this.socialInfo.details || this.socialInfo.details.length === 0;
      return !bool;
    },
    inGJJ() {
      let bool = !this.gjjInfo.details || this.gjjInfo.details.length === 0;
      return !bool;
    }
  },
  methods: {
    // 返回按钮
    back() {
      this.$router.go(-1);
    },
    getData() {
       console.log('获取社保详情，ID:', this.id);
       Get(`api/v1/social-securities/${this.id}`)
         .then(res => {
           console.log('API返回数据:', res);
           if (res.isSuccess) {
             console.log('员工信息:', res.data);
             // 直接使用res.data作为员工信息，因为API返回的数据结构中没有employeeInfo嵌套
             this.empInfo = res.data.employeeInfo;
             // 假设API返回的数据中包含soInfo和gjjInfo
             this.socialInfo = res.data.soInfo || {};
             this.gjjInfo = res.data.gjjInfo || {};
           } else {
             console.error('API请求失败:', res.msg);
             alert(res.msg);
           }
         })
         .catch(err => {
           console.error('请求出错:', err);
           alert('请求出错，请稍后重试');
         });
     },
    percent(num) {
      return toPercent(num, 2);
    },
    money(num) {
      return moneyFormat(num, 2)
    }
  },
  created() {},
  mounted() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  position: relative;
  padding: 32px;
  .infomation {
    padding: 25px 50px 0;
    margin-bottom: 32px;
    .infomation-title {
      display: flex;
      .tag {
        margin-left: 4px;
      }
    }
    .content {
      display: flex;
      align-items: center;
      padding: 26px 34px;
      overflow-x: auto;
      .sum {
        margin-right: 150px;
      }
    }
    .user_picture {
      width: 104px;
      height: 104px;
      margin-right: 64px;
    }
    .right {
      width: 240px;
    }
  }
  .contract {
    .session {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 45px 78px;
      min-height: 574px;
      &.table-session {
        padding: 26px 48px 62px;
        min-height: auto;
      }
      .session-title {
        margin-bottom: 40px;
      }
      .session-content {
        display: flex;
      }
    }
  }
}
.row-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.tag {
  margin-left: 4px;
}
.table-shadow {
  box-shadow: 0px 4px 8px 0px rgba(55, 14, 14, 0.08);
}

// 键值对
.key-value {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: stretch;
  margin-right: 50px;
  &:last-child {
    margin-right: 0;
  }
  .item {
    display: flex;
    margin-bottom: 32px;
  }
  .left {
    width: 84px;
    margin-right: 50px;
    text-align: right;
  }
  .right {
    width: 300px;
  }
  .key {
    margin-right: 50px;
    p {
      text-align: right;
    }
  }
  p {
    margin-bottom: 32px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.infomation .key-value {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.button-a.el-button {
  margin-left: 32px;
  padding: 14px 20px;
}
.back-btn-box {
  margin-bottom: 32px;
}
.goBackBtn {
  font-size: 16px !important;
  border: none !important;
  border-color: transparent !important;
}

::v-deep .el-tabs .el-tabs__nav-wrap::after {
  background-color: #ddd; // 标签页标签栏下边框颜色
}
</style>